import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

/**
 * Component for displaying and editing search options in a modal.
 */
@Component({
  selector: 'ft-search-options',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    FormsModule
  ],
  templateUrl: './search-options.component.html',
  styleUrls: ['./search-options.component.scss']
})
export class SearchOptionsComponent {
  private dialogRef = inject(MatDialogRef<SearchOptionsComponent>);
  public data = inject(MAT_DIALOG_DATA);

  public options: any;

  constructor() {
    // Clone options to avoid direct mutation before 'Ok'
    this.options = JSON.parse(JSON.stringify(this.data.options || {}));
  }

  /**
   * Closes the dialog and returns the updated options.
   */
  ok() {
    Object.assign(this.data.options, this.options);
    this.dialogRef.close(this.options);
  }

  /**
   * Closes the dialog without saving.
   */
  cancel() {
    this.dialogRef.close();
  }
}
